export default {

    updateSelected(state, payload) {
        state.selected = payload;
    },

    resetSelected(state, payload) {
        state.selected = [];
    },

    appendSelected(state, payload) {
        state.selected.push(payload);
    },

    removeSelected(state, payload) {
        let index = state.selected.findIndex(item => {
            return item[payload.trackBy] == payload.data[payload.trackBy];
        });

        state.selected.splice(index, 1);
    },

    removeTableDataItem(state, payload) {
        let index = state.tableData.findIndex(item => {
            return item[payload.trackBy] == payload.value;
        });

        state.tableData.splice(index, 1);
    },

    updateLoadingState(state, payload) {
        state.isLoading = payload;
    },

    commitTableData(state, payload) {
        state.tableData = payload;
    },

    concatTableData(state, payload) {
        state.tableData = state.tableData.concat(payload);
    },

    prependTableData(state, payload) {
        state.tableData = payload.concat(state.tableData);
    },

    resetTableData(state, payload) {
        state.tableData = [];
    },

    commitMeta(state, payload) {
        Object.assign(state.meta, payload);
    },

    updateParams(state, payload) {
        Object.assign(state.params, payload);
    },

    updatePage(state, payload) {
        state.params.page = payload;
    },

    triggerFilter(state, payload) {},

    reflow(state, payload) {},

    openColumnsModal(state, payload) {}
}
